import VConsole from 'vconsole'

const __vconsole = '__vconsole'
const showClass = 'show'
let initialized = false

const initializeVconsole = () => {
    // #ifdef H5
    if (!initialized && typeof document !== 'undefined') {
        // eslint-disable-next-line no-new
        new VConsole()
        initialized = true
    }
    // #endif
}

const hasClass = (ele, cls) => {
    return ele?.className?.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

const addClass = (ele, cls) => {
    if (ele && !hasClass(ele, cls)) ele.className += ' ' + cls
}

const removeClass = (ele, cls) => {
    if (ele && hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

const toggleClass = (ele, cls) => {
    if (hasClass(ele, cls)) {
        removeClass(ele, cls)
        uni.removeStorageSync(__vconsole)
    } else {
        addClass(ele, cls)
        uni.setStorageSync(__vconsole, showClass)
    }
}

export const maintainShowVconsole = async () => {
    if (uni.getStorageSync(__vconsole) === 'show') {
        initializeVconsole()
        const vconsoleEle = document.getElementById(__vconsole)
        addClass(vconsoleEle, showClass)
    }
}

export const toggleShowVconsole = () => {
    initializeVconsole()
    const vconsoleEle = document.getElementById(__vconsole)
    toggleClass(vconsoleEle, showClass)
}
